import { global_var, lms_v2_api } from "./cs-lab-config";

const LIMITED_FEATURES = {
  python: "python",
  html_css: "htmlCssJs",
  javascript: "htmlCssJs",
  vc3: "scratch",
  scratchjr: "scratchJr",
  sql2: "sql",
};

const ANSWER_TIMEOUT_MS = 4000;
let requestCounter = 0;

function canCreateProject(projectStack) {
  const feature = LIMITED_FEATURES[projectStack];

  if (!global_var.ENABLE_PAYMENT_MODULE || !feature || window.parent === window) {
    if (feature) {
      console.info("[payment-module] " + feature + ": not checked (" + (global_var.ENABLE_PAYMENT_MODULE ? "not opened inside company-ui" : "module disabled") + ")");
    }
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const requestId = "cslab-gate-" + ++requestCounter;

    const finish = (allowed, reason) => {
      console.info("[payment-module] " + feature + ": " + (allowed ? "allowed" : "blocked") + " (" + reason + ")");
      window.removeEventListener("message", onAnswer);
      clearTimeout(timer);
      resolve(allowed);
    };

    const onAnswer = (event) => {
      if (event.source !== window.parent) { return; }
      if (event.data?.type !== "CSLAB_CAN_CREATE_RESULT" || event.data.requestId !== requestId) { return; }
      finish(event.data.allowed !== false, "company-ui answered");
    };

    const timer = setTimeout(() => finish(true, "company-ui did not answer in time"), ANSWER_TIMEOUT_MS);
    window.addEventListener("message", onAnswer);
    window.parent.postMessage({ type: "CSLAB_CAN_CREATE", requestId, feature }, "*");
  });
}

// Tells company-ui a project was created so it can refresh the trial usage shown in its header.
function notifyProjectCreated() {
  if (global_var.ENABLE_PAYMENT_MODULE && window.parent !== window) {
    window.parent.postMessage({ type: "CSLAB_PROJECT_CREATED" }, "*");
  }
}

// Any project cslab-fe itself creates (the new project dialog, Scratch Jr, lab question projects)
// goes through POST /ideProjects/; tell company-ui once it has succeeded.
lms_v2_api.interceptors.response.use((response) => {
  const created = response.config?.method === "post" && /\/ideProjects\/?$/.test(response.config.url || "");
  if (created && response.data?.statusCode === 200 && response.data.ideProjectId) {
    notifyProjectCreated();
  }
  return response;
});

export { canCreateProject, notifyProjectCreated };
